import {useCallback, useEffect, useRef} from 'react'
import useIsMounted from '@github-ui/use-is-mounted'
import type {CopilotReviewEffortRequest} from '@github-ui/pull-request-page-data-tooling/copilot-review-effort'

export function useCopilotReviewEffortFailures() {
  const isMounted = useIsMounted()
  const failedRequestsRef = useRef(new Set<CopilotReviewEffortRequest>())
  const dismissFailures = useCallback(() => {
    for (const request of failedRequestsRef.current) request.dismissFailure?.()
    failedRequestsRef.current.clear()
  }, [])

  useEffect(() => dismissFailures, [dismissFailures])

  const failRequest = useCallback(
    (request: CopilotReviewEffortRequest | undefined) => {
      if (!request) return
      request.fail()
      if (isMounted()) failedRequestsRef.current.add(request)
      else request.dismissFailure?.()
    },
    [isMounted],
  )

  return {dismissFailures, failRequest}
}
